angular.module('impactx.panel').controller('ProductPanelCtrl', ProductPanelCtrl);

ProductPanelCtrl.$inject = ['productComparison', 'AddToBasketService', 'FavoritesService', 'ProductViewService',
    'TranslationService', '$redirect', '$context', 'ThemeWorldService', 'panelService', '$config', 'AppConfiguration'];

function ProductPanelCtrl(productComparison, AddToBasketService, FavoritesService, ProductViewService,
                          TranslationService, $redirect, $context, ThemeWorldService, panelService, $config, AppConfiguration) {
    var self = this;

    self.trns = {
        addToBasket: TranslationService.get('addToBasket'),
        addToSupplierBasket: TranslationService.get('addToSupplierBasket'),
        configure: TranslationService.get('configure'),
        addToProductView: TranslationService.get('addToProductView'),
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        removeFromProductView: TranslationService.get('removeFromProductView'),
        openBasket: TranslationService.get('openBasket'),
        openSupplierBasket: TranslationService.get('openSupplierBasket'),
        productNotAvailable: TranslationService.get('productNotAvailable'),
        addFreeform: TranslationService.get('addFreeForm')
    };
    self.addToBasketTimeout = AppConfiguration.get("addToBasketTimeout");

    self.getProductPanelColor = panelService.getProductPanelColor;

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.addToBasket = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
            if(self.addToBasketTimeout > 0)
            {
                const button = $event.currentTarget;
                button.disabled = true;
                setTimeout(() => { button.disabled = false; }, self.addToBasketTimeout);
            }
        }
        var actionTrns = self.forSupplier() ? self.trns.openSupplierBasket : self.trns.openBasket;
        AddToBasketService.addToBasket(self.product, (self.product.basketLink.price.minAmountFormatted && self.product.basketLink.price.minAmountFormatted.length > 0) ? self.product.basketLink.price.minAmountFormatted : self.product.basketLink.price.minAmount,
            actionTrns, impactX.isDefined(self, "product.basketLink.price.askSupplier"), $event);
    };

    self.addFreeForm = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }

        AddToBasketService.addFreeform(self.product, $event);
    };

    self.addToProductView = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addProductsToProductView([self.product], $event);
    };

    self.removeFromProductView = function($event) {
        var proIds = [];
        self.product.basketLink.canAddToProductView = true;
        self.product.basketLink.canRemoveFromProductView = false;
        proIds.push(self.product.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeProductsFromProductView($context.hasActiveProductView.id, proIds);
    };

    self.addToThemeWorld = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addProductsToThemeWorld([self.product]);
    };

    self.removeFromThemeWorld = function($event) {
        var proIds = [];
        self.product.basketLink.canAddToThemeWorld = true;
        self.product.basketLink.canRemoveFromThemeWorld = false;
        proIds.push(self.product.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeProductsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };

    self.redirectToProduct = function() {
        var link = "/product/" + self.product.id;
        if (self.product.isCompilationArticle) {
            link = "/compilation/" + self.product.id;
        }
        else {
            if (self.preConfiguredProducts) {
                link += "/true";
            }
        }
        $redirect.redirectTo(null, link);
    };

    self.redirectToManufacturer = function(event) {
        event.stopPropagation();
        $redirect.redirectTo(null, "/manufacturer/" + self.product.manufacturerId);
    };

    self.forSupplier = function() {
        return $context.hasSupplierBasket.value;
    };

    var addToBasketOption = {
        label: self.trns.addToBasket
    };
    addToBasketOption.func = self.addToBasket;

    var addToSupplierBasketLabel = self.trns.addToSupplierBasket || TranslationService.get('addToSupplierBasket');

    var toProductComparison = {
        label: TranslationService.get('addToProductComparison')
    };
    toProductComparison.func = function() {
        productComparison.addToComparison(self.product.id);
    };
    var addToFavorites = {
        label: TranslationService.get('addToFavorites')
    };
    addToFavorites.func = function() {
        FavoritesService.add(self.product);
        self.init();
    };
    var removeFromFavorites = {
        label: TranslationService.get('removeFromFavorites')
    };
    removeFromFavorites.func = function() {
        FavoritesService.remove(self.product);
        self.init();
    };

    var toExternalCat = {
        label: TranslationService.get("toExternalCat")
    };
    toExternalCat.func = function() {
        if (impactX.isDefined(self,"product.vcatalog.catalog.isExternal")) {
            OCICatalogService.toExternalCat(self.product.vcatalog.catalog);
        }
    };

    self.options = [];

    self.$onInit = function(){
        self.init();
    };

    self.init = function () {
        self.options.length = 0;
        if(!self.product.isConfigProduct || !self.product.basketLink.price.startPrice) {
            var productFavoriteFunc = self.product.isFavorite ? removeFromFavorites : addToFavorites;

            if(self.product.canBeAddedToProductComparison && $context.$securityManager.isProcessAllowed("CompareProducts")) {
                self.options.push(toProductComparison);
            }

            if(self.product.canBeAddedToFavorites && $context.$securityManager.isProcessAllowed("Favorite")) {
                self.options.push(productFavoriteFunc);
            }

            if (self.product.isActive) {
                if (self.product.basketLink.canAdd) {
                    if (self.product.basketLink.canAddToSupplierBasket && addToSupplierBasketLabel) {
                        //Rename
                        addToBasketOption.label = addToSupplierBasketLabel;
                    }
                    //
                    self.options.push(addToBasketOption)
                }
                
            }

            if(impactX.isDefined(self,"product.vcatalog.catalog.isExternal")) {
                self.options.push(toExternalCat);
            }
        }
    }
}